import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { blobPath } from "@circle-react/helpers/urlHelpers";
import type { PaywallCustomization } from "@circle-react/types";

interface CoverImageProps extends Pick<
  PaywallCustomization,
  "cover_image_url" | "cover_image"
> {
  className?: string;
}

export const CoverImage = ({
  cover_image_url,
  cover_image,
  className,
}: CoverImageProps) => {
  const imageUrl =
    cover_image_url ||
    blobPath({
      filename: "cover_image",
      signed_id: cover_image,
    });

  return (
    <img
      loading="lazy"
      alt=""
      src={imageUrl}
      className={classNames("relative w-full object-cover", className)}
      data-testid="paywall-cover-image"
    />
  );
};
